<template>
  <section class="listing">
    <div class="header">
      <div class="title">Faturamento</div>
      <!-- <button @click="print" class="button-save"><i class="fas fa-print"></i><span>Imprimir</span></button> -->
    </div>
    <form @submit.prevent class="form form-search">
      <input v-model="iniDate" @change="getData" type="date" />
      <input v-model="endDate" @change="getData" type="date" />
      <input v-model="search" type="text" placeholder="Pesquisar..." />
    </form>
    <div class="print-header">
      <div class="print-title">Faturamento</div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div class="sum-group">
          <div class="sum">
            <span>Total descontado</span>
            <span>{{ total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
          <div class="sum sum2">
            <span>Transações</span>
            <span>{{ transactions.length }}</span>
          </div>
          <div class="sum">
            <span>Válidos</span>
            <span>{{ transactionsOK.length }}</span>
          </div>
          <div class="sum sum2">
            <span>Cancelados</span>
            <span>{{ transactions.length - transactionsOK.length }}</span>
          </div>
        </div>
        <!-- <div class="sum-group" style="margin-bottom: 10px">
          <div class="sum sum2">
            <span>Ticket Médio</span>
            <span>{{ average.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
          <div class="sum">
            <span>Comissão</span>
            <span>{{ commission.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
        </div> -->
        <div v-for="(t, i) in filtered" :key="i" class="list">
          <div v-if="i > 0 ? getDay(t.date) !== getDay(filtered[i - 1].date) : true" class="calendar">
            <span>{{ getDay(t.date) }}</span>
            <span>{{ getMonthText(t.date) }}</span>
          </div>
          <div v-if="i > 0 ? getDay(t.date) === getDay(filtered[i - 1].date) : false" style="width: 50px"></div>
          <!--<div class="time-text">
            <span>{{ getHours(t.date) }}</span>
            <span>{{ getMinutes(t.date) }}</span>
          </div>-->
          <div class="data">
            <div class="main-data">{{ t.customer }}</div>
            <div class="detail-data">{{ t.product }}</div>
          </div>
          <div style="text-align: right">
            <div class="main-data">{{ t.refundAmount ? (t.amount - t.refundAmount).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : t.amount.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
            <div class="detail-data">{{ t.status === 'refunded' ? 'ESTORNADO' : '' }}</div>
          </div>
          <div class="actions" style="min-width: 50px; margin-left: 20px;">
            <button v-if="t.status !== 'refunded'" @click="refund = t" class="button-action">
              <i class="fas fa-undo"></i><span>ESTORNAR</span>
            </button>
            <!--<button v-if="t.valid" @click="detail = t" class="button-action" style="margin-left:10px;">
              <i class="far fa-eye"></i><span>DETALHAR</span>
            </button>-->
          </div>
        </div>
      </div>
    </transition>
    <TransactionRefund v-if="refund" :transaction="refund" :close="() => {
      this.refund = null
      this.getData() 
    }" />
    <UserTicket v-if="detail" :transaction="detail.id" :showDate="detail.dateshow" :close="() => this.detail = null"/>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/transaction'
import TransactionRefund from './TransactionRefund.vue'
import UserTicket from './UserTicket.vue'

export default {
  components: { TransactionRefund, UserTicket },
  data () {
    return {
      loading: true,
      transactions: [],
      iniDate: null,
      endDate: null,
      refund: null,
      search: '',
      detail: null,
      transactionsOK: []
    }
  },
  computed: {
    total () {
      this.transactionsOK = this.filtered.filter(x => x.status !== 'refunded')
      return this.filtered.filter(x => x.status !== 'refunded').map(x => Number(x.amount)).reduce((acc, cur) => acc + cur, 0)
    },
    average () {
      return this.filtered.length ? this.total / this.filtered.length : 0
      // const amount = this.transactions.map(x => Number(x.amount)).reduce((acc, cur) => acc + cur, 0)
      // const tickets = this.transactions.map(x => Number(x.tickets)).reduce((acc, cur) => acc + cur, 0)
      // return amount === 0 ? 0 : amount / tickets
    },
    commission () {
      return this.total > 0 ? this.total - this.total / 1.18 : 0
    },
    filtered () {
      return this.transactions.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    refund (value) {
      if (!value) this.getData()
    }
  },
  async mounted () {
    try {
      const dateIni = new Date()
      const dateFim = new Date()
      dateFim.setMonth(dateFim.getMonth() + 1)
      dateFim.setDate(1)
      dateFim.setDate(dateFim.getDate() - 1)
      this.endDate = dateFim.toISOString().split('T')[0]

      dateIni.setDate(1)
      // date.setDate(date.getDate() - 90)
      this.iniDate = dateIni.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const transactions = await getAll(this.iniDate, this.endDate)
        this.transactions = transactions || []
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    },
    print () {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.list {
  border: 1px solid #918f8f;
}
.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  margin-right: 10px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.form-search {
  display: flex;
  flex-direction: row;
  padding: 0;
  padding-bottom: 10px;

  input {
    flex: 1;
    margin: 0 5px;
  }
}

.button-action:hover {
  i {
    animation-name: ticket-image !important;
    animation-duration: 0.5s !important;
    animation-iteration-count: 1 !important;
  }
}

.sum-group {
  display: flex;
  flex-wrap: wrap;
  .sum {
    display: flex;
    flex-basis: calc(100% - 10px);
    margin: 0 5px 10px;
    span {
      text-align: center;
      padding: 8px 0;
      flex-basis: 50%;
    }
    span:nth-child(1) {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
      border-radius: 5px 0 0 5px;
      border: 1px solid $secondary-color;
    }
    span:nth-child(2) {
      font-weight: bold;
      color: $secondary-color;
      border-radius: 0 5px 5px 0;
      border: 1px solid $secondary-color;
    }
  }
  .sum2 {
    span:nth-child(1) {
      color: #555;
      background: #e5e5e5;
      border: 1px solid #555;
      border-right: none;
      font-weight: bold;
    }
    span:nth-child(2) {
      color: #555;
      border: 1px solid #555;
    }
  }
}

.button-save {
  color: #fff;
  border: none;
  border-radius: 100px;
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
  }
}

.print-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid $primary-color;
  padding: 20px 15px;
  margin-bottom: 20px !important;
}

.print-title {
  font-size: 2em;
  color: $primary-color;
  font-weight: 500;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
}

@media print {
  .admin-router {
    margin: 0;
  }
  .print-header {
    display: block;
  }
  .header, .form-search {
    display: none !important;
  }
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
  .list {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
